import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30217106"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main-wrap",
  id: "main-wrap-item"
}
const _hoisted_2 = { class: "button-wrap" }
const _hoisted_3 = { class: "cureent-price" }
const _hoisted_4 = { class: "price" }
const _hoisted_5 = {
  key: 0,
  class: "price-tips"
}

import { Button } from 'vant'
import { toThousands } from '@/utils/tools'
import { useRoute, useRouter } from 'vue-router'
import { getApplyInsuranceUserType } from '@/apis/insurance'
import { showToastLoading, clearToast } from '@/utils/tools'
import { judgeInsuranceItemUseUbi } from '@/defination/insurance'
import { computed, ref, Ref, nextTick, onDeactivated, reactive, onMounted } from 'vue'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { InsuranceJijiaConfirmInfoStorage } from '@/storage/insurance'
import {
  ConfirmInsureParams,
  DeviceJijiaInsuranceInfo,
  DeviceJijiaInsuranceInfoProjectItem,
  TestDeviceResult,
} from '@/types/insurance'
import AppHeader from '@/components/Header.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import AutoCheck from '../components/device-verify/auto-check.vue'
import FormPageTabWrap from '../components/form-page-tab-wrap.vue'
import BeforeCheck from '../components/device-verify/before-check.vue'
import InsuranceFormMainInfo from '../components/insurance-form-main-info.vue'
import InusranceFormDetailInfo from '../components/insurance-form-detail-info.vue'
import ElectronicComponentsRecord from '../components/device-verify/electronic-components-record.vue'

interface FormMainVm {
  validateHandle: () => Promise<boolean>
  getSubmitParams: () => ConfirmInsureParams
  showGiveupPopupHandle: () => void
}


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'insurance-jijia-insurance-form-page',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const pageLaoding = ref(true)
const $route = useRoute()
const $router = useRouter()
let formMainVm: FormMainVm | null = null
const electronicKey = ref(Date.now())
const testDeviceData: Ref<TestDeviceResult | null> = ref(null)
const currentDeviceCycleItem: Ref<DeviceJijiaInsuranceInfo | null> = ref(null)
const currentDeviceJijiaItem: Ref<DeviceJijiaInsuranceInfoProjectItem | null> = ref(null)
const currentInsurancePrice = computed(() => {
  if (!currentDeviceJijiaItem.value) {
    return 0
  }
  return toThousands(Number(currentDeviceJijiaItem.value.premium))
})
const beforeCheckVisible = ref(false)
const electronicComponentsRecordVisible = ref(false)
const autoCheckVisible = ref(false)
const isReplenishment = computed(() => $route.query.replenishment === '1')
const { addInsuranceFormPageKeepAlive } = useInsuranceStore()
const sn = computed(() => ($route.query.sn as string) || 'V50PP202204250027')
// 是否需要退款，额度补充的情况
const needRefund = computed(() => currentDeviceCycleItem.value?.exist_policy)
// 是否显示UBI系数
const isShowUbiInfo = computed(() => judgeInsuranceItemUseUbi(currentDeviceCycleItem.value))
// 判断是否为投保首周期
const isFirstYear = computed(() => currentDeviceCycleItem.value?.cycle_year == 1)
// 是否显示tab项
const showTabItem = ref(false)

// 基础信息加载完成响应
function infoLoadSuccessHandle() {
  pageLaoding.value = false
  clearToast()
  nextTick(() => {
    showTabItem.value = true
  })
}
// 初始化表单实例
function initFormMainVm(vm: FormMainVm) {
  formMainVm = vm
}

function updateCurrentCycleYearItem(value: DeviceJijiaInsuranceInfo) {
  // 获取当前投保信息
  currentDeviceCycleItem.value = value
}
function updateCurrentJijiaInsuranceItem(value: DeviceJijiaInsuranceInfoProjectItem) {
  currentDeviceJijiaItem.value = value
}
// 确认开始验机
function confirmStartCheckHandle() {
  beforeCheckVisible.value = false
  nextTick(() => {
    autoCheckVisible.value = true
  })
}
// 验机成功
function testSuccessHandle(data: TestDeviceResult) {
  console.log('data', data)
  autoCheckVisible.value = false
  testDeviceData.value = data
  nextTick(() => {
    electronicComponentsRecordVisible.value = true
  })
}
function nextHandle() {
  electronicComponentsRecordVisible.value = false
  comfirmHandle()
}
// 下一步操作
async function beforeConfirm() {
  const data = await formMainVm.validateHandle()
  if (!data) {
    return
  }
  // if (needRefund.value) {
  //   // 额度补充需要退上一个保险
  //   formMainVm.showGiveupPopupHandle()
  //   return
  // }
  if (currentDeviceCycleItem.value.is_test) {
    beforeCheckVisible.value = true
    return
  }
  comfirmHandle()
}

async function comfirmHandle() {
  const formMainParams = await formMainVm.getSubmitParams()
  if (!formMainParams) {
    return
  }
  const params: ConfirmInsureParams = {
    ...formMainParams,
    cycle_year: currentDeviceCycleItem.value.cycle_year,
    insurance_type: String(currentDeviceCycleItem.value.insurance_type),
    pro_type: String(currentDeviceJijiaItem.value.pro_type),
  }
  showToastLoading()
  try {
    let is_exist_quality = false
    if (Number(params.pro_type) === 2) {
      // 进阶版需要验证优质客户
      const data = await getApplyInsuranceUserType({
        sn: sn.value,
        type: params.applicant_info.personnelType === '1' ? '1' : '0',
        name: params.applicant_info.name,
        certificate_type: params.applicant_info.certificateType,
        certificate_no: params.applicant_info.certificateNo,
      })
      is_exist_quality = data.is_exist_quality
    }
    InsuranceJijiaConfirmInfoStorage.set({
      currentDeviceCycleItem: currentDeviceCycleItem.value,
      currentDeviceJijiaItem: currentDeviceJijiaItem.value,
      params,
      is_exist_quality,
    })
    addInsuranceFormPageKeepAlive()
    $router.push({
      name: 'insurance-jijia-insurance-form-confirm',
    })
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}
onDeactivated(() => {
  beforeCheckVisible.value = false
  autoCheckVisible.value = false
  setTimeout(() => {
    electronicComponentsRecordVisible.value = false
    electronicKey.value = Date.now()
  }, 500)
})
setTimeout(() => {
  showToastLoading()
}, 50)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "填写投保信息" }),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(InusranceFormDetailInfo, {
        sn: _unref(sn),
        onLoadSuccess: infoLoadSuccessHandle,
        onCurrentChange: updateCurrentCycleYearItem,
        isReplenishment: _unref(isReplenishment),
        onCurrentJijiaChange: updateCurrentJijiaInsuranceItem
      }, null, 8, ["sn", "isReplenishment"]),
      _createVNode(InsuranceFormMainInfo, {
        onInit: initFormMainVm,
        onConfirmGiveup: comfirmHandle
      })
    ], 512), [
      [_vShow, !pageLaoding.value]
    ]),
    (showTabItem.value)
      ? (_openBlock(), _createBlock(FormPageTabWrap, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(CommonFooterWrap, { class: "van-hairline--top" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(_unref(isFirstYear) ? '' : 'left-wrap')
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(" 实付保费： "),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, "￥" + _toDisplayString(_unref(currentInsurancePrice)), 1)
              ])
            ]),
            (_unref(isShowUbiInfo))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "实付保费 = 应交保费 x 保险系数"))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_unref(Button), {
            class: "next-button xa-vant-button",
            round: "",
            onClick: beforeConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交投保")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, !pageLaoding.value]
    ]),
    _createVNode(BeforeCheck, {
      show: beforeCheckVisible.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((beforeCheckVisible).value = $event)),
      onConfirmStart: confirmStartCheckHandle
    }, null, 8, ["show"]),
    _createVNode(AutoCheck, {
      show: autoCheckVisible.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((autoCheckVisible).value = $event)),
      sn: _unref(sn),
      onTestSuccess: testSuccessHandle
    }, null, 8, ["show", "sn"]),
    (_openBlock(), _createBlock(ElectronicComponentsRecord, {
      show: electronicComponentsRecordVisible.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((electronicComponentsRecordVisible).value = $event)),
      data: testDeviceData.value,
      onNext: nextHandle,
      key: electronicKey.value
    }, null, 8, ["show", "data"]))
  ], 64))
}
}

})